<template>
  <div>
      <div class="content">
          <div class="left-content">
            <div class="nav-bar">
              <div>
                <el-input placeholder="想居住哪个小区？" class="input-with-select" v-model="keyWord">
                    <el-button slot="append" icon="el-icon-search" @click="searchByKeyWord"></el-button>
                </el-input>
              </div>
              <el-row class="screen-item">
                <el-col :span="8" class='pointer'>
                    <el-dropdown trigger="click" @command="chooseStreetTown">
                    <span class="el-dropdown-link">
                      <span>{{streetTownName?streetTownName:'区域'}}</span>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(street, index) in streetList" :key="index" :command="street.index" >{{street.text}}</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
                <!-- <el-col :span="6" class='pointer'>
                    <el-dropdown trigger="click" @command="choosePrice">
                    <span class="el-dropdown-link">
                        <span>{{choosedPrice?choosedPrice:'价格'}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">                        
                        <el-dropdown-item v-for="(money, index) in rentMoneyList" :key="index" :command="money.index">{{money.text}}</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </el-col> -->
                <el-col :span="8" class='pointer'>
                    <el-dropdown trigger="click" @command="chooseBussiness">
                    <span class="el-dropdown-link">
                      <span>{{businessName?businessName:'商圈'}}</span>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(type, index) in bussinessTownList" :key="index" :command="type.index" >{{type.text}}</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
                <el-col :span="8" class='pointer'>
                    <el-dropdown trigger="click" @command="chooseMetro">
                    <span class="el-dropdown-link">
                      <span>{{metroName?metroName:'地铁'}}</span>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(type, index) in metroTownList" :key="index" :command="type.index">{{type.text}}</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
              </el-row>
            </div>
            <div class="infinite-list-wrapper house-list" style="overflow:auto;width:100%;">
              <div class="infinite-list" infinite-scroll-disabled="disable" infinite-scroll-distance="10">
                  <div class="house-item infinite-list-item" @click="houseDetail(room.id)" v-for="(room, index) in roomList" :key="index">
                      <div class="item-left">
                          <el-image :src="(room.cover != null && room.cover != undefined) ? room.cover : '@/assets/imgs/pic.jpg'" style="width: 158px; height: 130px">
                            <div slot="error" class="image-slot">
                                <img :src="require('@/assets/imgs/pic.jpg')" style="width: 158px; height: 130px">
                            </div>
                          </el-image>
                      </div>
                      <div class="item-right">
                          <p class="house-type">{{room.name}}</p>
                          <p class="price">
                              <!-- <span>{{room.rental}}</span>
                              <span>元/月</span> -->
                          </p>
                          <p class="address">
                              <img src="../../assets/imgs/ico_map.png" alt="">
                              <span>{{room.address}}</span>
                          </p>
                      </div>
                  </div>
                  <p v-if="loading">加载中...</p>
                  <p v-if="noMore">没有更多了</p>
              </div>
            </div>
          </div>
          <div class="right-content">
              <div id="allmap" style="width:100%;height:100%;"></div>
          </div>
      </div>
      <el-divider></el-divider>
  </div>
</template>
<script>
import TDTMap from '../../helper/TMapInit'
import PortalApi from '@/api/portal/index'
export default {
  data () {
    return {
      map: null,
      center: {lng: 121.265324, lat: 31.375513},
      zoom: 13, // 缩放级别，值越大，地图显示越深
      rentMoneyList: [
        {
          index : 0,
          text : "不限",
          value : ""
        },
        {
          index : 1,
          text : "0-1500",
          value : "0-1500"
        },
        {
          index : 2,
          text : "1500-2500",
          value : "1500-2500"
        },
        {
          index : 3,
          text : "2500-4000",
          value : "2500-4000"
        },
        {
          index : 4,
          text : "4000-8000",
          value : "4000-8000"
        },
        {
          index : 5,
          text : "8000-10000",
          value : "8000-10000"
        }
        ,
        {
          index : 6,
          text : "10000-20000",
          value : "10000-20000"
        }
      ],
      streetList: [],
      bussinessTownList: [],
      metroTownList: [],
      businessCode: "",
      businessName: '',
      streetTownCode:"",
      streetTownName:'',
      metroCode:"",
      metroName:"",
      min_money: 0,
      max_money: 0,
      page_index: 1,
      page_size: 5,
      roomList: [],      
      choosedPrice: '',
      keyWord: '',
      active: null,
      deviceObj: [],
      pageIndex: 0,
      disabled: true,
      loading: false,
      noMore: false,
      conditionList:[],
      tmap:null,
    }
  },
  components: {
  },
  computed: {
    disable () {
      return this.disabled
    }
  },
  methods: {
    houseDetail (id) {
      this.$router.push({path: '/HouseDetail', query: {id: id}})
    },
    // 获取房屋列表
    getRoomlist () {
      this.loading = true      
      PortalApi.getCommunityList(1,500, this.conditionList)
        .then(
            res=>{
                this.loading = false
                this.roomList = res.data;
                // this.setMapLabel();
                // console.log(this.roomList);
                this.noMore = true
                this.getCurrentPosition()
                // var count = res.count
                // if (count % this.page_size > 0) {
                //   this.pageIndex = parseInt(count / this.page_size) + 1;
                // } else {
                //   this.pageIndex = parseInt(count / this.page_size)
                // }
                // if (this.page_index === this.pageIndex) {
                //   this.disabled = true
                //   this.noMore = true
                // } else {
                //   this.disabled = false
                // }
            },err=>
            {
              this.$message({
                message: err,
                type:"error",
                center: true
              })
            }
      ).catch(error=>{
          this.$message({
            message: error,
            type:"error",
            center: true
          })
      })      
    },
    // 定位
    getCurrentPosition () {
      TDTMap.init().then((TMap)=>{
          if(!this.tmap){
              this.tmap = new TMap.Map('allmap')
              this.tmap.enableScrollWheelZoom();
              this.tmap.addControl(new TMap.Control.Scale());
              this.tmap.addControl(new TMap.Control.Zoom({
                  position:T_ANCHOR_BOTTOM_LEFT
              }));
          }
          var point = new TMap.LngLat(this.center.lng, this.center.lat)
          this.tmap.centerAndZoom(point, this.zoom); 
          this.setTMapLabel(TMap)
          this.tmap.addEventListener('zoomend', () => {
              this.setTMapLabel(TMap)
          })
      })
    },
    setTMapLabel(TMap){
        this.deviceObj.forEach(el => {
            this.tmap.removeOverLay(el)
        })
        this.deviceObj = []
        this.roomList.forEach(el => {
            if(el.coordinate){
                let coordinatE_X = el.coordinate.split(',')[0]
                let coordinatE_Y = el.coordinate.split(',')[1]
                let point = new TMap.LngLat(coordinatE_X, coordinatE_Y)
                var opts = {
                    text:'<div class="ellipse-style"><div style="background: rgba(41,102,199,0.83);padding:5px 10px;border-radius:60px;"><p>' + el.name + '</p></div></div>',
                    position: point, // 指定文本标注所在的地理位置
                    offset: new TMap.Point(30, -30) // 设置文本偏移量
                }
                var label = new TMap.Label(opts) // 创建文本标注对象
                label.addEventListener('click', () => {
                  this.$router.push({path: '/HouseDetail', query: {id: el.id}})
                })
                this.tmap.addOverLay(label)
                this.deviceObj.push(label)
            }
        }, error => {
            this.$message({
            message: error,
            center: true
        })})
    },
    // 获取类型列表
    getNavInfo () {
      PortalApi.getNavInfo().then(res => {
        var that = this;
        that.streetList.push({"index": 0, "value": "", "text": "不限"});
        that.bussinessTownList.push({"index": 0, "value": "", "text": "不限"});
        that.metroTownList.push({"index": 0, "value": "", "text": "不限"});

        if(res.data.streetTownList){
          res.data.streetTownList.forEach(function(item,index){
            that.streetList.push({"index": index + 1, "value": item.code, "text": item.name})
          })
        }

        if(res.data.bussinessTownList){
          res.data.bussinessTownList.forEach(function(item,index){
            that.bussinessTownList.push({"index": index + 1, "value": item.code, "text": item.name})
          })
        }

        if(res.data.metroTownList){
          res.data.metroTownList.forEach(function(item,index){
            that.metroTownList.push({"index": index + 1, "value": item.code, "text": item.name})
          })
        }

      }, error => {
        this.$message({
          message: error,
          center: true
        })
      })
    },

    searchByKeyWord(){
      this.setCondition({id:"",type:"0",name:this.keyWord})
    },

    // 筛选条件——商圈
    chooseBussiness (value) {
      this.businessName = this.bussinessTownList[value].text
      this.businessCode = this.bussinessTownList[value].value
      this.active = value     

      this.setCondition({id:this.businessCode,type:"3",name:""})
    },
    
    // 筛选条件——区域
    chooseStreetTown (val) {      
      this.streetTownName = this.streetList[val].text
      this.streetTownCode = this.streetList[val].value
      this.active = val
      this.setCondition({id:this.streetTownCode,type:"1",name:""})
    },
    // 筛选条件——价格
    choosePrice (val) {
      this.choosedPrice = this.rentMoneyList[val].value
      this.setCondition({id:"",type:"6",name:this.choosedPrice})
    },

    // 筛选条件——地铁
    chooseMetro (val) {
      this.metroName = this.metroTownList[val].text
      this.metroCode = this.metroTownList[val].value
      this.active = val
      this.setCondition({id:this.metroCode,type:"2",name:""})
    },
    // 查询条件设置
    setCondition(obj){
      // 重设页数
      this.page_index = 1;
        let newConditionList = [];
        this.conditionList.forEach(function(item){
          if(item.type != obj.type){
             newConditionList.push(item);
          }
        })

        if(obj.id != "" || obj.name != ""){
          newConditionList.push(obj);
        }
        else{
          if(obj.type == "3"){
            this.businessName = "";
          }
          else if(obj.type == "1"){
            this.streetTownName = "";
          }
          else if(obj.type == "2"){
            this.metroName = "";
          }
        }

        this.conditionList = newConditionList;

        this.getRoomlist();
    },

    init () {
      this.getNavInfo()
      this.getRoomlist()
    }
  },
  created () {
    
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
.content{
    width:100%;
    margin:0 auto;
    margin-top:146px;
    display: flex;
    justify-content: space-between;
}
.left-content{
    width:350px;
    padding:16px 0;
    height:80vh;
    overflow: hidden;
    position: relative;
    margin: 0 5px;

    .nav-bar{
      background-color: #FFFFFF;
      padding-top:15px;

      .screen-item{
          display: flex;
          justify-content: space-between;
          margin:10px 0;
      }
      .screen-item .el-col{
          border:0.55px solid #e6e6e6;

          /* 下拉框样式 */
          .el-dropdown{
            width:100%;
          }
          .el-dropdown .el-dropdown-link{
            width: 100%;
            display: inline-block;
          }
          .el-dropdown .el-dropdown-link>span{
            width: 60%;
            overflow: hidden;
            display: inline-block;
            word-break: keep-all;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
      }
    }

    .house-list{
      position: absolute;
      top:110px;
      bottom:0;
      width: 100%;

      .house-item{
          width:100%;
          display: flex;
          margin-bottom:10px;

          .item-left{              
              border-radius: 4px;
              overflow: hidden;
              width:169px;
              height:130px;
          }

          .item-right {
            padding-top:5px;
            width:169px;
            margin-left:10px;
            text-align: left;
            color:#999999;

            .house-type{
              font-weight: 600;
              color:#666666;
            }

            .price{
                margin:16px 0;
            }

            .price span:first-child{
                color: #f14511;
                font-size: 20px;
                font-weight: 500;
            }

            .price span:last-child,.item-right .detail,.item-right .address{
                font-size: 12px;
            }

            .address {
              margin:10px 0;
            }

            .address img{
              width:10px;
            }

            .address span{
              font-size:12px;
              color:#999999;
            }
          }
      }
    }
}

.right-content{
    width:80%;
    height:80vh;
    /deep/ .tdt-label.tdt-clickable{
        background: transparent;
        border: none;
        box-shadow: none;
    }
    /deep/ .ellipse-style{
        font-size: 14px;
        width: auto;
        height: auto;
        overflow: hidden;
        background: transparent;
        color: #FFFFFF;
        border:none;
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: center;
    }
}

.active{
  color:#2966c7;
}
</style>
